import { useEffect } from "react";
import { getIn, useFormikContext } from "formik";
import { useLocation } from "react-router-dom";

type ValidateOnMountProps<T> = {
    shouldValidate: boolean;
    validate: (values: T, setFieldError: (field: string, message: string | undefined) => void) => boolean;
};

export function ValidateOnMount<T>({ shouldValidate, validate }: ValidateOnMountProps<T>) {
    const { values, setFieldError } = useFormikContext<T>();
    const location = useLocation();
    const isBackNavigation = (location.state as any)?.isBack ?? false;
    useEffect(() => {
        if (shouldValidate && !isBackNavigation) {
            validate(values, (field, message) => {
                if (!message) return;

                const value = getIn(values, field);
                if (!value) return;
                if (Array.isArray(value) && value.length === 0) return;
                if (typeof value === 'object' && Object.keys(value).length === 0) return;

                setFieldError(field, message);
            });
        }
    }, []);
    return null;
}
